// Helper: Create image from blob URL
export const createImageFromBlob = (blobUrl) =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener('load', () => resolve(image));
    image.addEventListener('error', (error) => reject(error));
    image.src = blobUrl;
  });

// Helper: Get cropped image blob with circular mask
export async function getCroppedImg(blobUrl, croppedAreaPixels, fileName = 'cropped-image.png') {
  const image = await createImageFromBlob(blobUrl);
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');

  if (!ctx) throw new Error('Failed to get 2D context');

  const pixelRatio = window.devicePixelRatio || 1;

  canvas.width = croppedAreaPixels.width * pixelRatio;
  canvas.height = croppedAreaPixels.height * pixelRatio;

  ctx.scale(pixelRatio, pixelRatio);
  ctx.imageSmoothingQuality = 'high';

  ctx.drawImage(
    image,
    croppedAreaPixels.x,
    croppedAreaPixels.y,
    croppedAreaPixels.width,
    croppedAreaPixels.height,
    0,
    0,
    croppedAreaPixels.width,
    croppedAreaPixels.height
  );

  // Apply circular mask
  ctx.globalCompositeOperation = 'destination-in';
  ctx.beginPath();
  ctx.arc(
    croppedAreaPixels.width / 2,
    croppedAreaPixels.height / 2,
    croppedAreaPixels.width / 2,
    0,
    Math.PI * 2
  );
  ctx.closePath();
  ctx.fill();
  ctx.globalCompositeOperation = 'source-over';

  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        if (!blob) {
          reject(new Error('Failed to create blob from canvas.'));
          return;
        }
        blob.name = fileName;
        const fileUrl = URL.createObjectURL(blob);
        resolve({ blob, fileUrl });
      },
      'image/png',
      1
    );
  });
}

// Helper: Auto-crop logo from URL using backend proxy (center square crop with circular mask)
export async function autoCropLogoFromUrl(imageUrl, apiUrl) {
  const token = localStorage.getItem('brandvox_token');
  const proxyUrl = `${apiUrl}/api/v1/brand/proxy-image?url=${encodeURIComponent(imageUrl)}`;

  const response = await fetch(proxyUrl, {
    headers: {
      'Authorization': `Bearer ${token}`,
    },
  });

  if (!response.ok) throw new Error('Failed to fetch image via proxy');

  const blob = await response.blob();
  const blobUrl = URL.createObjectURL(blob);

  try {
    const img = await createImageFromBlob(blobUrl);

    // Calculate center square crop
    const size = Math.min(img.width, img.height);
    const x = (img.width - size) / 2;
    const y = (img.height - size) / 2;

    const croppedAreaPixels = {
      x, y, width: size, height: size
    };

    const result = await getCroppedImg(blobUrl, croppedAreaPixels, `brand-logo-${Date.now()}.png`);

    // Clean up the temporary blob URL
    URL.revokeObjectURL(blobUrl);

    return result;
  } catch (error) {
    // Clean up on error
    URL.revokeObjectURL(blobUrl);
    throw error;
  }
}
